import debounce from 'lodash/debounce';
export default function () {
    return debounce;
  }